<template>
  <v-col cols="12">
    <v-row>
      <v-col cols="12">
        <v-btn color="primary"
               @click="addRow()">
          {{ addNewLabel }}
          <v-icon right>add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-for="(item, i) in items" :key="`${_uid}-${id}-${i}`">
      <v-col cols="12">
        <v-card>
          <slot name="controls" v-bind="{ item, index: i, model }">
            <v-toolbar flat dense v-if="!disabled">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon
                         color="accent"
                         v-on="on"
                         @click.stop="addRow(item, i)">
                    <v-icon dense>filter_none</v-icon>
                  </v-btn>
                </template>
                <span>{{ duplicateLabel }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon
                         color="accent"
                         v-on="on"
                         @click.stop="$refs.confirm.open(i)">
                    <v-icon dense>delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ removeLabel }}</span>
              </v-tooltip>
            </v-toolbar>
          </slot>
          <v-card-text>
            <v-row>
              <slot name="item" v-bind="{ item, index: i }"></slot>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <ConfirmDialog ref="confirm"
                   title="CONFIRM DELETE"
                   width="450"
                   @continue="removeRow($event)">
      <strong>Are you sure you would like to delete this item?</strong>
    </ConfirmDialog>
  </v-col>
</template>

<script>
/**
 * Tracks repeatable data for complex objects/array
 *
 * The model property is used primarily to tell the repeater how to generate new items
 * representing an empty state. If none is provided, clicking the Add New button will generate
 * a new item containing an empty string
 *
 * An ID is required to properly track everything
 * Setting the disabled property to true will turn off the toolbar
 *
 * TODO: Consider disabling the Add New button as well?
 * TODO: Consider renaming the model property to something more clear (ie: itemModel)
 */
export default {
  name: 'Repeater',
  model: {
    prop: 'values',
    event: 'repeaterupdate',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    values: Array,
    disabled: Boolean,
    model: {
      type: [String, Number, Boolean, Array, Object],
      default: '',
    },
    addNewLabel: {
      type: String,
      default: 'Add New',
    },
    duplicateLabel: {
      type: String,
      default: 'Duplicate',
    },
    removeLabel: {
      type: String,
      default: 'Remove',
    },
  },
  data() {
    return {
      items: this.values || [],
    };
  },
  watch: {
    items: {
      immediate: true,
      handler(v) {
        if (!v.length) {
          this.addRow();
        }
        this.$emit('repeaterupdate', this.items);
      },
    },
  },
  methods: {
    addRow(item = this.model, index = this.items.length) {
      let m = item;
      if (Array.isArray(m) || typeof m === 'object') {
        m = this.clone(m);
      }
      this.updateRow(m, index);
    },
    updateRow(v, i) {
      this.items.splice(i, 0, v);
    },
    removeRow(i) {
      this.$delete(this.items, i);
    },
    clone(obj) {
      // Return a shallow clone of an array-like object
      return JSON.parse(JSON.stringify(obj));
    },
  },
};
</script>
